export default "__VITE_ASSET__DFiceaXV__"